import styled from "@emotion/styled";
import { Box, HStack, Text, Flex, Icon, IconButton } from "@chakra-ui/react";
import {
  primary,
  white,
  textSecondary,
  primaryAlt,
  backgroundLight,
} from "../../../utils/colors";
import { useTranslation } from "react-i18next";
import {
  TbChevronsLeft,
  TbChevronLeft,
  TbChevronRight,
  TbChevronsRight,
  // TbEye,
} from "react-icons/tb";
// import DropdownButton from "../../buttons/DropdownButton";
import DropdownButtonNew from "../../buttons/DropdownButtonNew";
import useThemeColors from "../../../hooks/useThemeColors";
import useIsMobile from "../../../hooks/useIsMobile";
// import { FaEye } from "react-icons/fa6";

const TablePagination = ({
  isSmall,
  loading,
  page,
  pages,
  pageSize,
  pageSizes,
  setPage,
  setPageSize,
  totalCount,
  p,
}) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const { newBorderMode } = useThemeColors();

  const canPreviousPage = page > 1;

  const canNextPage = page < pages;

  // const dropdownOptions = [
  //   t("employee.doctorTreatmentPlansButton"),
  //   t("employee.coordinatorTreatmentPlansButton"),
  // ];

  const gotoPage = (page) => {
    setPage(page);
  };

  const previousPage = () => {
    setPage(page - 1);
  };

  const nextPage = () => {
    setPage(page + 1);
  };

  const goToLastPage = () => {
    gotoPage(pages);
  };

  // Handle page size change by directly accepting the size value
  const handlePageSizeChange = (size) => {
    setPageSize(size); // Set the new page size
    setPage(1); // Reset to the first page
  };

  // console.log("pageSizes", pageSizes);
  // console.log("pageSize", pageSize);

  // console.log("totalCount", totalCount);
  // console.log("pages", pages);

  return (
    <>
      {!loading ? (
        <Flex
          justifyContent="space-between"
          alignItems="center"
          borderTop={
            isMobile
              ? `0px solid ${newBorderMode}`
              : `1px solid ${newBorderMode}`
          }
          borderBottom={isMobile ? `0px solid ${newBorderMode}` : "none"}
          padding={p ? p : "1rem 1.5rem"}
          w="100%"

          // borderTop={
          //   totalCount > 0
          //     ? `0px solid ${newBorderMode}`
          //     : `1px solid ${newBorderMode}`
          // }
        >
          <Box maxW={["30%", "70%"]} position="relative" zIndex="90">
            <Flex alignItems="center" gap="0.5rem">
              {!isMobile ? (
                <Text
                  color={textSecondary}
                  fontSize={isSmall ? "xs" : "0.8rem  "}
                  mr="0"
                >
                  {t("common.show")}
                </Text>
              ) : (
                // <Icon as={TbEye} color={textSecondary} fontSize="0.8rem" />
                <></>
              )}
              <DropdownButtonNew
                initialLabel={pageSize}
                items={pageSizes.map((size) => size.toString())}
                onSelectItem={(size) => handlePageSizeChange(Number(size))}
              />

              {!isMobile ? (
                <Flex
                  fontSize={isSmall ? "xs" : "0.8rem  "}
                  color={textSecondary}
                  whiteSpace="nowrap"
                >
                  <Text as="span">
                    {t("common.itemsPerPage")} {t("common.from")} {totalCount}
                  </Text>
                </Flex>
              ) : (
                <Flex
                  fontSize={isSmall ? "xs" : "0.8rem  "}
                  color={textSecondary}
                  whiteSpace="nowrap"
                >
                  <Text as="span">
                    {t("common.from")} {totalCount}
                  </Text>
                </Flex>
              )}
            </Flex>
          </Box>
          <HStack spacing={2}>
            {!isMobile && (
              <IconButton
                // w="40px"
                onClick={() => gotoPage(1)}
                isDisabled={!canPreviousPage}
                size={isSmall ? "xs" : "sm"}
                fontSize={isSmall ? "xs" : "0.8rem  "}
                borderRadius="10rem"
                bg={backgroundLight}
                color={textSecondary}
                _hover={{
                  bg: primaryAlt,
                  color: white,
                }}
              >
                <Icon
                  as={TbChevronsLeft}
                  style={{
                    pointerEvents: canPreviousPage ? "auto" : "none",
                  }}
                />
              </IconButton>
            )}

            {page !== 1 && (
              <IconButton
                // w="40px"
                onClick={() => previousPage()}
                isDisabled={!canPreviousPage}
                size="sm"
                borderRadius="10rem"
                fontSize="0.8rem"
                bg={backgroundLight}
                color={textSecondary}
                _hover={{
                  bg: primaryAlt,
                  color: white,
                }}
              >
                <Icon
                  as={TbChevronLeft}
                  // color={textSecondary}

                  style={{
                    pointerEvents: canPreviousPage ? "auto" : "none",
                  }}
                />
              </IconButton>
            )}

            {page - 1 > 0 && (
              <IconButton
                onClick={() => gotoPage(page - 1)}
                isDisabled={!canPreviousPage}
                size="sm"
                borderRadius="10rem"
                fontSize="0.8rem"
                bg={backgroundLight}
                color={textSecondary}
                _hover={{
                  bg: primaryAlt,
                  color: white,
                }}
              >
                <Text fontSize="0.8rem">{page - 1}</Text>
              </IconButton>
            )}
            <Buttonas
              onClick={() => gotoPage(page)}
              className="active"
              size="sm"
              // h="2.25rem"
              borderRadius="10rem"
              fontSize="0.8rem"
              bg={backgroundLight}
              color={textSecondary}
              _hover={{
                bg: primaryAlt,
                color: white,
              }}
              flexShrink={0}
            >
              <Text fontSize="0.8rem">{page}</Text>
            </Buttonas>
            {page < pages && (
              <Buttonas
                onClick={() => gotoPage(page + 1)}
                isDisabled={!canNextPage}
                size="sm"
                borderRadius="10rem"
                fontSize="0.8rem"
                bg={backgroundLight}
                color={textSecondary}
                _hover={{
                  bg: primaryAlt,
                  color: white,
                }}
              >
                <Text fontSize="0.8rem">{page + 1}</Text>
              </Buttonas>
            )}

            {page !== pages && (
              <Buttonas
                // w="40px"
                onClick={() => nextPage()}
                isDisabled={!canNextPage}
                size="sm"
                borderRadius="10rem"
                fontSize="0.8rem"
                bg={backgroundLight}
                color={textSecondary}
                _hover={{
                  bg: primaryAlt,
                  color: white,
                }}
              >
                <Icon
                  as={TbChevronRight}
                  style={{
                    pointerEvents: canNextPage ? "auto" : "none",
                  }}
                />
              </Buttonas>
            )}

            {page !== pages && !isMobile && (
              <IconButton
                onClick={() => goToLastPage()}
                isDisabled={!canNextPage}
                size="sm"
                borderRadius="10rem"
                fontSize="0.8rem"
                bg={[white, backgroundLight]}
                color={textSecondary}
                _hover={{
                  bg: primaryAlt,
                  color: white,
                }}
              >
                <Icon
                  as={TbChevronsRight}
                  style={{
                    pointerEvents: canPreviousPage ? "auto" : "none",
                  }}
                />
              </IconButton>
            )}
          </HStack>
        </Flex>
      ) : (
        <Flex
          justifyContent="center"
          alignItems="center"
          padding="1rem 1.5rem"
          w="100%"
        >
          {/* <Spinner size="sm" color={primary} /> */}
        </Flex>
      )}
    </>
  );
};

const Buttonas = styled(IconButton)`
  /* width: 40px; */
  background: ${backgroundLight};
  color: ${textSecondary};

  &.active {
    background: ${primary};
    color: ${white};
  }
  &:hover {
    background: ${primaryAlt};
    color: ${white};
  }
`;

export default TablePagination;
